import { Logo } from '@/components/ui/logo';

/** Accessible name for rows that render `OnlyOnTitle` as their visible heading. */
export const ONLY_ON_TITLE_LABEL = 'Only on Taboo TV';

export const OnlyOnTitle = (
  <span className="inline-flex items-center gap-2 align-middle">
    Only on
    <Logo size="md" linkTo="" className="h-[1.1em] w-auto" />
  </span>
);
